var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center py-2"},[_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"flow-straight"})])])}]

export { render, staticRenderFns }